import { render, staticRenderFns } from "./DashboardLeft.vue?vue&type=template&id=246447bf&scoped=true&"
import script from "./DashboardLeft.vue?vue&type=script&lang=js&"
export * from "./DashboardLeft.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLeft.vue?vue&type=style&index=0&id=246447bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246447bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
